import { Component, OnInit, Input } from '@angular/core';

import { Material } from "../../material/shared/material.model";
import { MaterialCodigoBarra } from "../shared/material-codigo-barra.model";
import { MaterialCodigoBarraService } from "../shared/material-codigo-barra.service";
import { materialCodigoBarraTitle } from "../../material/shared/data.service";
import { UtilService } from "../../../../shared/services/util.service";
import { MaterialService } from "../../material/shared/material.service";

declare var swal: any;

@Component({
    selector: 'material-codigo-barra-list',
    template: require('./material-codigo-barra-list.component.html'),
})

export class MaterialCodigoBarraListComponent implements OnInit {
    @Input() materialObject: Material = new Material();

    materialCodigoBarraTitle: any = materialCodigoBarraTitle;
    list: Array<MaterialCodigoBarra> = [];
    showDisabled: boolean = false;
    showLoad: boolean = true;

    constructor(
        private _service: MaterialCodigoBarraService,
        private _materialService: MaterialService,
        private _utilService: UtilService
    ){}

    ngOnInit() {
        var onDone = (function(Response: any) {
            if (!Response.error) {
                this.list = Response;
            } else {
                console.log("Erro: " + Response.message);
            }
            this.showLoad = false;
        }.bind(this));

        this._service.onGetbyMaterial(this.materialObject.id, onDone);
    }

    onclickGoToAdd() {
        this._materialService.clearStorage();

        var object: any = new MaterialCodigoBarra();
        object.material = this.materialObject;

        this._service.setStorage(object);
        this._service.goToAdd();
    }

    onclickDelete(item: any) {
        swal({
                title: "Você deseja realmente excluir este item?",
                text: "O item será desativado.",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Sim, Excluir",
                cancelButtonText: "Cancelar",
                closeOnConfirm: false
            },
            function() {
                this.onDelete(item);
            }.bind(this)
        );
    }

    onclickGoToEdit(item: any) {
        this._materialService.clearStorage();

        item.material = this.materialObject;

        this._service.setStorage(item);
        this._service.goToEdit(item.id);
    }

    private onDelete(item: any) {
        var onDone = (function(Response: any) {
            if (!Response.error) {
                var x: number, lenX: number;
                for (x = 0, lenX = this.list.length; x < lenX; x++) {
                    if (this.list[x].id === item.id) {
                        this.list[x].ativo = false;
                        break;
                    }
                }
                this._utilService.swalMessageDeleteSuccess();
            } else {
                this._utilService.swalMessageDeleteError();
            }
        }.bind(this));

        this._service.onDelete(item.id, onDone);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/materiais/material-codigo-barra/material-codigo-barra-list/material-codigo-barra-list.component.ts
 **/